import NovartisContactFormButton from '@components/chat-stream/novartis-contact-form-button';
import { MarkdownRenderer } from '@components/markdown-renderer';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@components/ui/dialog';

interface IGenericModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  userQuery?: string;
}

function GenericModal(props: IGenericModalProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-[425px] max-h-[400px] sm:max-h-[500px] overflow-y-auto rounded-md">
        <DialogHeader>
          <DialogTitle className="mt-3 sm:mt-0 sm:mb-3 text-left">{props.title}</DialogTitle>
        </DialogHeader>
        <MarkdownRenderer content={props.description} />
        <NovartisContactFormButton align="center" query={props.userQuery} />
      </DialogContent>
    </Dialog>
  );
}

export default GenericModal;
